import { createSelector } from 'reselect';
import qs from 'qs';

export const initialisedSelector = createSelector(
  state => state.app.initialised,
  initialised => initialised
);

export const loadingSelector = createSelector(
  state => state.app.loading,
  loading => loading
);

export const getAwaitingCalculation = createSelector(
  state => state.app.awaitingCalculation,
  awaitingCalculation => awaitingCalculation
);

export const getLabels = createSelector(
  state => state.app.data.labels,
  labels => labels
);

export const getErrorSelector = createSelector(
  state => state.app.error,
  error => error
);

export const getStep = createSelector(
  state => state.app.step,
  step => step
);

export const getCompletedSteps = createSelector(
  state => state.app.completedSteps,
  completedSteps => completedSteps
);

export const getBikeModel = createSelector(
  state => state.app.data.bikeModel,
  bikeModel => bikeModel
);

export const getFinanceOption = createSelector(
  state => state.app.form.financeOption,
  state => state.app.data.financeOption.financeOptions,
  (selectedFinanceOptionId, financeOptions) =>
    selectedFinanceOptionId ? financeOptions.find(financeOption => financeOption.id === selectedFinanceOptionId) : null
);

export const getFinanceOptionContent = createSelector(
  state => state.app.data.financeOption.content,
  financeOptionContent => financeOptionContent
);

export const getFinanceOptions = createSelector(
  state => state.app.data.financeOption.financeOptions,
  financeOptions => financeOptions
);

export const getOfferBanner = createSelector(
  state => state.app.data.offerBanner,
  offerBanner => offerBanner
);

export const getTerms = createSelector(
  state => state.app.data.termsAndConditions,
  termsAndConditions => termsAndConditions
);

export const getAddressFields = createSelector(
  state => state.app.data.customerDetails.addressFields,
  addressFields => addressFields
);

export const getBikeConditions = createSelector(
  state => state.app.data.bikeConditions,
  bikeConditions =>
    bikeConditions.map(bikeCondition => ({
      ...bikeCondition,
      name: bikeCondition.value,
    }))
);

export const getFormData = createSelector(
  state => state.app.form,
  formData => formData
);

export const getMakes = createSelector(
  state => state.app.data.bikeMakes,
  makes => makes
);

export const getModels = createSelector(
  state => state.app.makes,
  state => state.app.form.make,
  (makes, selectedMakeId) => makes.find(make => make.id === selectedMakeId)?.models || []
);

export const getSelectedMake = createSelector(
  state => state.app.form.make,
  state => state.app.makes,
  (selectedMakeId, makes) => makes.find(make => make.id === selectedMakeId)
);

export const getSelectedModel = createSelector(
  getSelectedMake,
  state => state.app.form.model,
  (selectedMake, selectedModelId) => selectedMake?.models.find(model => model.id === selectedModelId)
);

export const getSelectedColour = createSelector(
  state => state.app.data.bikeModel.colours,
  state => state.app.configuration?.colourId,
  (bikeColours, loadedConfigurationColourId) => {
    const { colourId } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    return bikeColours.find(colour => colour.id === (colourId || loadedConfigurationColourId));
  }
);

export const getFinanceProviderUrl = createSelector(
  state => state.app.data.financeProviderUrl,
  financeProviderUrl => financeProviderUrl
);

export const getIsFinanceProviderCodeweavers = createSelector(
  state => state.app.data.isFinanceProviderCodeweavers,
  isFinanceProviderCodeweavers => isFinanceProviderCodeweavers
);

export const getBikeCondition = createSelector(
  state => state.app.form.condition,
  state => state.app.data.bikeConditions,
  (bikeConditionId, bikeConditions) => bikeConditions.find(bikeCondition => bikeCondition.id === bikeConditionId)
);

export const getDealers = createSelector(
  state => state.app.dealers,
  dealers => dealers
);

export const getSubStep = createSelector(
  state => state.app.subStep,
  subStep => subStep
);

export const getSelectedDealer = createSelector(
  state => state.app.form.dealerId,
  state => state.app.dealers,
  (dealerId, dealers) => dealers.find(dealer => dealer.DealerId === dealerId)
);

export const getConsent = createSelector(
  state => state.app.data.dealerDetails.consent,
  consent => consent
);

export const getWhatHappensNext = createSelector(
  state => state.app.data.whatHappensNext,
  whatHappensNext => whatHappensNext
);

export const getLoadedConfiguration = createSelector(
  state => state.app.configuration,
  configuration => configuration
);

export const currencyCodeSelector = createSelector(
  state => state.app.data.currency,
  currencyCode => currencyCode
);

export const getSummary = createSelector(
  state => state.app.data.summary,
  summary => summary
);

export const getGoal = createSelector(
  state => state.app.data.goal,
  goal => goal
);

export const lgpdSelector = createSelector(
  state => state.app.data.lgpd,
  lgpd => lgpd
);

export const getCalculations = createSelector(
  state => state.app.calculations,
  calculations => calculations
);

export const getSelectedWarrantyPack = createSelector(
  state => state.app.configuration?.extras.warrantyPacks?.[0],
  warrantyPack => warrantyPack
);

export const getSelectedServicePack = createSelector(
  state => state.app.configuration?.extras.servicingPacks?.[0],
  servicePack => servicePack
);

export const getGoalId = goal =>
  createSelector(
    state => state.app.data.goals[goal],
    goalId => goalId
  );

export const getProvincialData = createSelector(
  state => state.app.data.province,
  state => state.app.data.fees,
  (province, fees) => ({
    province,
    fees,
  })
);
